<!--
  Componente de modal de confirmação reutilizável.
-->

<template>
  <div
    id="modalConfirm"
    ref="modalConfirm"
    class="modal"
    tabindex="-1"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
        </div>
        <div class="modal-body">
          <p>{{ message }}</p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            @click="handleCancelClick"
          >
            {{ $t('voltar') }}
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="handleOkClick"
          >
            {{ $t('comunidade.modalCapa.confirmar') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as bootstrap from 'bootstrap';

export default {
  name: "ModalConfirm",

  props: {
    title: String,
    message: String,
    redirectTo: {
      type: String,
      default: null
    }
  },

  mounted() {
    this.modalInstance = new bootstrap.Modal(this.$refs.modalConfirm, {});
  },

  methods: {
    openModal() {
      this.modalInstance.show();
    },

    handleOkClick() {
      this.modalInstance.hide();
      this.$emit('confirmed');
      if (this.redirectTo) {
        this.$router.push(this.redirectTo);
      }
    },
    
    handleCancelClick() {
      this.modalInstance.hide();
      this.$emit('cancelled');
    }
  }
}
</script>